
<header class="header">
    <div class="header-grp">
      <div class="title">
        <h3>Login</h3>
      </div>
    </div>
  </header>
  <main>
    <div class="loginWraper">
      <div class="title">
        <h2>Welcome</h2>
      </div>
      <form [formGroup]="loginForm" (ngSubmit)="onLogin()">
        <div class="form-group">
          <input
            type="email"
            class="form-control"
            placeholder="Email"
            formControlName="email"
          />
        </div>
  
        <div class="form-group position-relative">
          <input
            [type]="showPassword ? 'text' : 'password'"
            class="form-control"
            placeholder="Password"
            formControlName="password"
          />
          <span class="passEye" (click)="togglePasswordVisibility()">
            <i class="ti ti-eye" *ngIf="showPassword"></i>
            <i class="ti ti-eye-off" *ngIf="!showPassword"></i>
          </span>
        </div>
        <button type="submit" class="btn-common">Login</button>
      </form>
    </div>
  </main>